"use client";
import LandingV6 from "@/src/components/Home/LandingV6";

export { SectionThree, SectionFour, SectionFive, SectionSix } from "@/src/components/Home/LegacySections";

export default function LandingPage() {
  return <LandingV6 />;
}
